<div class="main-container" [class.no-scroll]="isOverlayOpen">
  <div class="application-overlay" *ngIf="isOverlayOpen">
    <router-outlet></router-outlet>
  </div>

  <div
    class="panel"
    [class.absolute-panel]="
      router.url.includes(
        '/my-contractor-registrations/workflow-application-print-summary'
      )
    "
    *ngIf="showOverlay"
  >
    <router-outlet></router-outlet>
  </div>

  <div
    class="my-contractor-registrations-page"
    [class.hidden]="showOverlay || isOverlayOpen"
  >
    <div class="my-contractor-registrations-header">
      <div class="header-title-section">
        <wm-common-text
          class="page-title"
          [data]="{ text: 'Contractors' }"
        ></wm-common-text>

        <wm-common-text
          class="page-subtitle"
          [data]="{ text: 'Review, edit and update your Contractor info here.' }"
        ></wm-common-text>
      </div>

      <wm-common-button
        class="new-registration-btn"
        [data]="{
          text: 'NEW REGISTRATION',
          type: 'primary'
        }"
        (click)="onNewRegistrationClick()"
      >
      </wm-common-button>
    </div>

    <div class="contractor-registrations-content-card">
      <div class="contractor-registrations-toolbar">
        <wm-filter-builder
          *ngIf="filtersReady"
          [tableType]="'Applicant'"
          id="myContractorRegistrationsFilters"
          [params]="filterCriteria"
          [defaultFilters]="[]"
          [filterTypes]="filterTypes"
          [savedFilters]="true"
          [useMuiLayout]="true"
          [layoutTitle]="'Contractors'"
          [showSimpleSearch]="true"
          [simpleSearchTitle]="'Search'"
          [showColumnsSettings]="false"
          [isNoData]="isNoData"
          [hasFewData]="hasFewData"
          (filtersChange)="filtersChanged($event)"
        >
          <ng-template #sortByTemplate>
            <div class="sort-content">
              <div class="sort-by-wrapper"  #sortWrapper
>
                <button
                  class="sort-btn"
                  type="button"
                  (click)="toggleSort($event)"
                >
                  Sort by |
                  <span class="selected-sort-label">
                    {{ selectedSortLabel }}
                  </span>

                  <span class="material-icons dropdown-icon">
                    keyboard_arrow_down
                  </span>
                </button>

                <div
                  class="sort-menu"
                  *ngIf="isSortOpen"
                  [class.open-above]="isSortOpenAbove"
                  (click)="$event.stopPropagation()"
                >
                  <button
                    *ngFor="let option of sortOptions"
                    class="sort-item"
                    [class.active]="option.label === selectedSortLabel"
                    type="button"
                    (click)="selectSort(option)"
                  >
                    {{ option.label }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </wm-filter-builder>
      </div>

      <div class="contractor-registrations-table">
        <!-- Added by Amisha on 2026-07-23.
             Reason: retain applicant column selections when dynamic
             requirement metadata refreshes. -->
        <wm-common-table
          [tableType]="'Applicant'"
          [isLoading]="isLoading"
          [columns]="columns"
          [displayedColumns]="displayedColumns"
          [data]="data"
          [serverSidePagination]="true"
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          [pageSize]="pageSize"
          [sortField]="sortField"
          [sortDescending]="sortDescending"
          (sortChanged)="onSortChanged($event)"
          (pageChange)="onPageChange($event)"
          (displayedColumnsChange)="onDisplayedColumnsChange($event)"
          [showRowsPerPage]="true"
          [showTotalRecords]="true"
          [totalRecords]="totalRecords"
          (rowsPerPageChange)="onRowsPerPageChange($event)"
          [pageSizeStorageKey]="'contractor-registration-applicant-janus'"
        >
        </wm-common-table>
      </div>
    </div>
  </div>
<wm-common-confirmation-modal
  #registrationActionModal
  [data]="registrationActionModalData"
  (onNoClick)="cancelAction()"
  (onYesClick)="confirmAction()"
  [isApplicantMobileview]="true"
></wm-common-confirmation-modal>
<wm-common-confirmation-modal
  [data]="successModalData"
  (onYesClick)="closeSuccessModal()"
  [isApplicantMobileview]="true"
></wm-common-confirmation-modal>
</div>
